const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ArmsIndustry extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.ArmsIndustry,
            "Compare levels of infantry, cavalry, and artillery technology. Each civilization gains 2 resources for each technology type in which it is the best (or tied for best).",
            {}
        )
    }
}

module.exports = ArmsIndustry;